import '@mantine/core/styles.css';
import '@mantine/dates/styles.css';
import '@mantine/notifications/styles.css';
import './assets/fonts/font.css';
import i18n from '../src/config/localization';

import { MantineProvider } from '@mantine/core';
import { Notifications } from '@mantine/notifications';
import { I18nextProvider } from 'react-i18next';

import theme from './config/theme';
import Router from './Router';

function App() {
  return (
    <MantineProvider theme={theme}>
      <I18nextProvider i18n={i18n}>
        <Notifications />
        <Router />
      </I18nextProvider>
    </MantineProvider>
  );
}

export default App;
